<template>
  <div>

    <v-dialog  width = "60VW" scrollable  persistent
    v-model="modals.creator">
     <creatorWrapper :base="init.base" :newProc="init.newProc" :modals="modals" :procs="procs"  ></creatorWrapper>
    </v-dialog>


    <v-dialog  width = "60VW" scrollable  persistent
    v-model="modals.params">
     <creatorWrapper :newProc="init.newProc" :modals="modals" :procs="procs"  ></creatorWrapper>
    </v-dialog>




    <v-dialog max-width="450"  persistent    v-model="modals.deleter">
    <deleteProc  :procs='procs' :modals="modals"  ></deleteProc>
    </v-dialog>


  <v-container fluid >
  <v-layout  d-flex>

  <v-card>

      <v-toolbar height="42"     flat>
      <v-toolbar-title style="color:#273C51;font-size:1.6em">  Авто обновление процессов ({{this.procs.items.length}}) </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn  @click="createProc()" flat color="#4A76A8"> <v-icon left> mdi-plus</v-icon> Создать Процесс</v-btn>

    </v-toolbar>

  <v-card-text>


<proc_list :procs='procs' :modals='modals' ></proc_list>


  </v-card-text>
  </v-card>





  </v-layout >
  </v-container>




  </div>
</template>




<script>
import axios from 'axios'
import proc_list from './proc_list.vue'
import deleteProc from './delete_proc.vue'
import creatorWrapper from './creator/creatorWrapper.vue'
//import delete_proc from './delete_groups.vue'
export default {


props: ['procs','modals'],
components:{proc_list,creatorWrapper,deleteProc},
data(){
return {

init:{
  base:{
    newProc: {},
  },
  newProc :{
  loading: false,

  // Общие настройки активности'
        sensor: 3,
        reactOnNewFollowers: true,
        reactOnNewFollowersOut: false,

        name: '',
        contentType: 'pages',   // нужно для заданий итд
        selectedType: 'groups',  //  Какой тип активности нужно создать

        typeList: [
          {
            procName: 'Новые подписки сообществ',
            procType:'groups',
            selectAllGroups: false,
            selectedGroups: [],
            groupsAll: [],
            selectedTasksForNewFollowers: [],
            selectedTasksForNewFollowersOut: [],
            tasksAllForNewFollowers: [],
            tasksAllForNewFollowersOut: [],
            
            recordResourceInfoNewIn: false,
            recordResourceInfoNewOut: false,
          },
          {
            procName: 'Подписки страниц',
            procType:'pages',
            selectAllPages: false,
            selectedPages: [],
            pagesAll: [],
            selectedTasksForNewFollowersPages: [],
            selectedTasksForNewFollowersOutPages: [],
            selectedTasksForNewFriendsPages: [],
            selectedTasksForNewFriendsOutPages: [],
            selectedTasksForNewFriendsOutBySelfPages: [],
            tasksAllForNewFollowersPages: [],
            tasksAllForNewFollowersOutPages: [],
            tasksAllForNewFriendsPages: [],
            tasksAllForNewFriendsOutPages: [],
            tasksAllForNewFriendsOutBySelfPages: [],
          },
          {
            procType:'procs',
            procName: 'Обновления процессов',
            procsAll: [],
            selectAllBindings: false,
          },
        ],




      },
  },


}
},
methods: {
  createProc: function(){
    this.init.newProc = JSON.parse(this.init.base.newProc)
    this.modals.creator = true
  },
},

mounted(){

const task_for_export = axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {method: 'POST',data: {contentType: this.init.newProc.contentType,}})
.then( response => {
       this.init.newProc.typeList[0].tasksAllForNewFollowers = response.data
       this.init.newProc.typeList[0].tasksAllForNewFollowersOut = response.data

       this.init.newProc.typeList[1].tasksAllForNewFollowersPages = response.data
       this.init.newProc.typeList[1].tasksAllForNewFollowersOutPages = response.data
       this.init.newProc.typeList[1].tasksAllForNewFriendsPages = response.data
       this.init.newProc.typeList[1].tasksAllForNewFriendsOutPages = response.data
       this.init.newProc.typeList[1].tasksAllForNewFriendsOutBySelfPages = response.data
     })

const groups_get = axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get.php', {method: 'POST'})
.then(response => {
        if(response.data.response){
        this.init.newProc.typeList[0].groupsAll = response.data.response
         }
      })

const pages_get = axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_get.php', {method: 'POST' })
.then(response => {
        if(response.data){
        this.init.newProc.typeList[1].pagesAll = response.data
          }
       })
const procs_get = axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/history_get.php', {method: 'GET', contentType: 'JSONP' })
.then(response => {
       if(response.data){

       response.data.map((item)=>{
         if(item.subscribers.length > 10){
           item.subscribers = JSON.parse(item.subscribers).activiti
         } else {
           item.subscribers = []
         }

       })
       this.init.newProc.typeList[2].procsAll = response.data


           }
        })
Promise.all([task_for_export,groups_get,pages_get,procs_get])
.then(()=>{
   this.init.base.newProc = JSON.stringify(this.init.newProc)
 })

},



}
</script>
